<template>
    <div class="news-block">
        <div v-for="item in news" :key="item.article_id">
            <div class="info">
                {{moment(item.datetime).format('HH:mm')}}
                <img src="../../assets/img/clock.svg" alt="Clock">
                {{moment(item.datetime).format('DD MMM')}}
            </div>
            <a class="headline" :href="item.url" target="_blank">{{item.headline}}</a>
        </div>
    </div>
</template>

<script>
export default {
    name:'NewsBlock',
    props:['news']
}
</script>

<style lang="scss" scoped>
.news-block{
    position: relative;
    background: var(--input-bg-color);
    border: 1px solid var(--input-br-color);
    border-radius: 10px;
    padding: 13px;
    min-height: 100px;
    max-height: 294px;
    overflow: auto;
    & > div{
        margin-bottom: 15px;
        &:last-child{
            margin-bottom: 0;
        }
        .info{
            font-size: 12px;
            line-height: 18px;
            color: #8D8BE1;
            img{
                vertical-align: sub;
            }
        }
        a.headline{
            font-size: 13px;
            line-height: 18px;
            color: #ABA7C9;
            text-decoration: none;
            display: inline-block;
        }
    }
    &.loading{
        pointer-events: none;
        &:before{
            content: "";
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            position: absolute;
            z-index: 5;
            background: var(--loading-bg);
        }
        &:after{
            content: "";
            width: 64px;
            height: 64px;
            background: url('../../assets/img/loader.svg') no-repeat;;
            position: absolute;
            z-index: 10;
            left:50%;
            top:50%;
            transform: translate(-50%,-50%);
        }
    }
}
</style>